let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4rEic")).then(() => parcelRequire('2A3LE'));